
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { EnvironmentService } from "../environment.service";
import { IProductBranchPricingPutDtoModel } from "../../models/product/dto/pricing/product-branch-pricing-put.model";
import { IProductBranchPricingGetDtoModels } from "../../models/product/dto/pricing/product-branch-pricing-get.models";
import { IProductBranchPricingPutDtoModels } from "../../models/product/dto/pricing/product-branch-pricing-put.models";
import { map } from "rxjs/operators";

@Injectable({
    providedIn: 'root'
})
export class ProductBranchPricingService {
    fullPath: string;
    private delay = 3000;
    constructor(private readonly httpClient: HttpClient, private envService: EnvironmentService) {
        this.fullPath = `${envService?.settings?.apiUrl}/Products`;
    }

    public update(id: string, dto: IProductBranchPricingPutDtoModels | undefined): Observable<any> {
        return this.httpClient.put<IProductBranchPricingPutDtoModel>(`${this.fullPath}/${id}/branchInfo`, dto).pipe(map(x => true));
    }

    public get(id: string): Observable<IProductBranchPricingGetDtoModels | undefined> {
        return this.httpClient.get<IProductBranchPricingGetDtoModels>(`${this.fullPath}/${id}/branchInfo`);
    }
}